import { render, staticRenderFns } from "./studentStoryInfo.vue?vue&type=template&id=154f3e94"
import script from "./studentStoryInfo.vue?vue&type=script&lang=js"
export * from "./studentStoryInfo.vue?vue&type=script&lang=js"
import style0 from "./studentStoryInfo.vue?vue&type=style&index=0&id=154f3e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports